import { getDocs, collection } from 'firebase/firestore';

import { db } from '../services/firebase.js';

import { silentTrack } from './silentTrack.js';

export const ContentDiscoveryService = {
    /**
     * Discover vocabulary content for a chapter
     * Scans: feature_testing/Korea_University/Level{level}/Vocab/Chapter{chapter}
     */
    async discoverVocabularyContent(level, chapter, institution = 'Korea_University') {
        return silentTrack(async () => {
            const collectionPath = `feature_testing/${institution}/Level${level}/Vocab/Chapter${chapter}`;
            const querySnapshot = await getDocs(collection(db, collectionPath));

            const vocabularyContent = [];
            querySnapshot.forEach((doc) => {
                vocabularyContent.push({
                    id: doc.id,
                    data: doc.data()
                });
            });

            console.log(`✓ Discovered ${vocabularyContent.length} vocabulary items for Level ${level} Chapter ${chapter}`);
            return vocabularyContent;
        }, 'discover_vocabulary_content');
    },

    /**
     * Discover grammar content for a chapter
     * Scans: feature_testing/Korea_University/Level{level}/Grammar/Chapter{chapter}
     */
    async discoverGrammarContent(level, chapter, institution = 'Korea_University') {
        return silentTrack(async () => {
            const collectionPath = `feature_testing/${institution}/Level${level}/Grammar/Chapter${chapter}`;
            const querySnapshot = await getDocs(collection(db, collectionPath));

            const grammarContent = [];
            querySnapshot.forEach((doc) => {
                grammarContent.push({
                    id: doc.id,
                    data: doc.data()
                });
            });

            console.log(`✓ Discovered ${grammarContent.length} grammar items for Level ${level} Chapter ${chapter}`);
            return grammarContent;
        }, 'discover_grammar_content');
    },

    /**
     * Get content metadata for a chapter
     */
    async getContentMetadata(level, chapter, institution = 'Korea_University') {
        return silentTrack(async () => {
            const vocabulary = await this.discoverVocabularyContent(level, chapter, institution);
            const grammar = await this.discoverGrammarContent(level, chapter, institution);

            return {
                vocabulary: vocabulary || [],
                grammar: grammar || [],
                total: (vocabulary?.length || 0) + (grammar?.length || 0)
            };
        }, 'get_content_metadata');
    }
};
